import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/login";
import Registered from "@/views/registered";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      component: Login,
      meta: {
        auth: false
      }
    },
    {
      path: "/registered",
      component: Registered,
      meta: {
        auth: false
      }
    }
  ]
});
